var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2269_7979)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3669 28.7091V26.0558C12.3669 25.6585 12.689 25.3364 13.0863 25.3364C13.4836 25.3364 13.8057 25.6585 13.8057 26.0558V28.7091C13.8056 29.1063 13.4835 29.4285 13.0863 29.4285C12.6891 29.4285 12.367 29.1063 12.3669 28.7091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71436 28.5937L9.71436 15.3278C9.71436 14.9305 10.0364 14.6084 10.4337 14.6084C10.831 14.6084 11.1531 14.9305 11.1531 15.3278L11.1531 28.5937C11.1531 28.991 10.831 29.3131 10.4337 29.3131C10.0364 29.3131 9.71436 28.991 9.71436 28.5937Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0962 28.709V22.9415C17.0962 22.5442 17.4183 22.2222 17.8155 22.2222C18.2128 22.2222 18.5349 22.5442 18.5349 22.9415V28.709C18.5349 29.1063 18.2128 29.4284 17.8155 29.4284C17.4183 29.4284 17.0962 29.1063 17.0962 28.709Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8845 28.7089V24.3253C21.8845 23.928 22.2066 23.606 22.6039 23.606C23.0012 23.606 23.3232 23.928 23.3232 24.3253V28.7089C23.3232 29.1062 23.0012 29.4283 22.6039 29.4283C22.2066 29.4283 21.8845 29.1062 21.8845 28.7089Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6135 28.7091V20.4034C26.6135 20.0061 26.9356 19.6841 27.3329 19.6841C27.7302 19.6841 28.0522 20.0061 28.0522 20.4034V28.7091C28.0522 29.1064 27.7302 29.4284 27.3329 29.4284C26.9356 29.4284 26.6135 29.1064 26.6135 28.7091Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2776 16.2164C27.5827 15.9622 28.0362 16.0036 28.2906 16.3085C28.545 16.6137 28.5038 17.0678 28.1986 17.3222L23.0078 21.6481C22.7931 21.8271 22.4937 21.8648 22.2407 21.7458L17.7798 19.6467L13.522 23.639C13.2322 23.9104 12.7771 23.8957 12.5055 23.606C12.2338 23.3162 12.2487 22.8605 12.5385 22.5888L17.1525 18.2635L17.2375 18.1947C17.4458 18.0517 17.7172 18.0273 17.9506 18.1371L22.4388 20.2488L27.2776 16.2164Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7562 15.4653C28.9516 15.4847 29.1323 15.5835 29.2541 15.7407C29.3931 15.9204 29.439 16.1552 29.3781 16.374L28.774 18.5439C28.6675 18.9266 28.2706 19.1501 27.8879 19.0435C27.5053 18.9369 27.2814 18.5407 27.388 18.158L27.7331 16.9171L26.5024 16.9402C26.1053 16.9475 25.7775 16.6317 25.7701 16.2346C25.7628 15.8374 26.0786 15.5096 26.4757 15.5023L28.672 15.4622L28.7562 15.4653Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6814 10.5715L17.7572 10.5757C17.9334 10.5945 18.0973 10.6778 18.2167 10.8111L20.7745 13.666C21.0378 13.9599 21.0153 14.4108 20.7239 14.6769L18.1661 17.0134C18.0336 17.1343 17.8607 17.2009 17.6814 17.201H10.4337C10.0364 17.201 9.71436 16.8789 9.71436 16.4816V11.2909C9.71436 10.8936 10.0364 10.5715 10.4337 10.5715H17.6814ZM11.1531 15.7623H17.4018L19.2276 14.0946L17.3603 12.0102H11.1531V15.7623Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2269_7979",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E04226"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioStocks);
export default __webpack_public_path__ + "static/media/portfolio-stocks.66f9ae94cb6cc4737cadda6baf5f3ab8.svg";
export { ForwardRef as ReactComponent };